







































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { UpdateLocationRequest } from '../../types/request';
import { MemberProfile } from '../../types/response';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
declare var google: any;

@Component({
    mixins: [validationMixin],
    data() {
        return {
            locationName: '',
            insuranceCompany: '',
            adjusterEmail: '',
            address: {
                fullAddress: '',
                state: '',
                city: '',
                landmark: '',
                zip: '',
            },
        };
    },
    validations() {
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        const rules = {
            locationName: {
            required,
        },
        insuranceCompany:  {
                    required,
                },
                adjusterEmail:  {
                    required,
                    email,
                },
        address: {
            fullAddress: {
                required,
            },
            city: {
                required,
            },
            state: {
                required,
            },
            zip: {
                required,
            },
        },
        };
        if (!memberProfile.isCaseManager) {
            delete rules.adjusterEmail;
            delete rules.insuranceCompany;
        }
        return rules;
    },
})
export default class UpdateLocationModal extends Vue {
    private locationGoogleAddress: any;
    private show = false;
    private memberProfile: MemberProfile = null as any;

    public mounted() {
        this.getGoogleAddress();
        this.getLocation();
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('locationAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }

    /**
     * @author <Aniket.P>
     * @description API - Returns organization locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of locations
     * @returns List of oragnazation lists
     * @throws InvalidRequestException if organization id is invalid
     */
    private async getLocation() {
        const locationId = this.$route.params.id;
        const response = await ObjectFactory.getOrganizationService().getLocationDetails(this.$store.state.serverUrl,
        locationId);
        if (response.success && response.data) {
            this.$data.locationName = response.data.locationName;
            this.$data.address = response.data.locationAddress;
            this.$data.adjusterEmail = response.data.adjusterEmail;
            this.$data.insuranceCompany = response.data.insuranceCompany;
            this.show = true;
        } else {
            CommonUtils.showError(response);
        }
    }

    /**
     * @author <Amol.D>
     * @description - update location
     * @param req {Request} - calls update location API
     * @param res {Response} - Express Response - success result
     * @returns location list
     * @throws InvalidRequestException if location not found already exists
     */
    private async updateLocation() {
        const locationId = this.$route.params.id;
        const updateLocationRequest: UpdateLocationRequest = {
            adjusterEmail: this.$data.adjusterEmail,
            insuranceCompany: this.$data.insuranceCompany,
            locationName: this.$data.locationName,
            locationAddress: this.$data.address,
        };
        const response = await ObjectFactory.getOrganizationService().updateLocation(this.$store.state.serverUrl,
        locationId, updateLocationRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_LOCATION'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }
}
